<div class="gw-flex gw-min-w-0 gw-w-full gw-justify-between gw-gap-x-small">
  <div
    *ngFor="let step of [].constructor(steps); let i = index"
    class="gw-h-1 gw-min-w-[16px] gw-flex-1 gw-rounded-full gw-transition-colors"
    [class.gw-bg-background-accent-1]="i < currentStep"
    [class.gw-bg-background-neutral-2]="i >= currentStep"
  ></div>
</div>
